import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/affiliations`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/affiliations`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/affiliations/create`, parameters)
    },

    users: {
        retrieve (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/affiliations/client`, parameters)
        },
    },

    clients: {
        retrieve (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/affiliations/user`, parameters)
        },
    },

    requests: {
        retrieve (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/affiliationsrequests`, parameters)
        },

        update (parameters) {
            return requester.put(`${BACKEND_API_V1_URL}/affiliationsrequests`, parameters)
        },

        create (parameters) {
            return requester.post(`${BACKEND_API_V1_URL}/affiliationsrequests/create`, parameters)
        },
    }
}
